module.exports = __webpack_public_path__ + "static/reagan-ef2d8425b1d334ff8885e712ca763448.jpg";